export enum PAYMENT_PROVIDER {
  adyen = 'adyen',
  comercia = 'comercia'
}
